import {
    createContext,
    FunctionComponent,
    PropsWithChildren,
    useContext,
    useRef,
} from "react";

const Id = createContext<() => string>(() => {
    throw new TypeError("Please wrap your application with IdProvider");
});

type IdState = {
    id: number;
    get(): string;
};
const useIdGetter = (prefix = "id") => {
    const ref = useRef<IdState>();
    if (!ref.current) {
        const me = { id: 0, get: () => `${prefix}-${me.id++}` };
        ref.current = me;
    }
    return ref.current.get;
};

export const IdProvider: FunctionComponent<PropsWithChildren<{}>> = ({
    children,
}) => {
    const get = useIdGetter();
    return <Id.Provider value={get}>{children}</Id.Provider>;
};

// TODO: use built-in React hook once project is transitioned to React 18
export const useId = () => {
    const getter = useContext(Id);
    const ref = useRef<string>();
    if (!ref.current) ref.current = getter();
    return ref.current;
};
